import { createPortal } from 'react-dom';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const isVideoUrl = (url) => /\.(mp4|mov|webm)/i.test(url || '');

const PhotoLightbox = ({ photos, currentIdx, onClose, onSetIdx }) => {
  if (!photos || photos.length === 0) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[300] bg-black/95 flex items-center justify-center"
      onClick={onClose}
      data-testid="photo-lightbox"
    >
      <button
        className="absolute top-4 right-4 z-10 w-11 h-11 rounded-full bg-black/50 flex items-center justify-center text-white/90 hover:text-white hover:bg-black/70 transition-colors"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        data-testid="lightbox-close"
      >
        <X size={20} />
      </button>

      {photos.length > 1 && (
        <button
          className="absolute left-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-black/40 flex items-center justify-center text-white/80 hover:text-white hover:bg-black/60 transition-colors"
          onClick={(e) => { e.stopPropagation(); onSetIdx((currentIdx - 1 + photos.length) % photos.length); }}
        >
          <ChevronLeft size={22} />
        </button>
      )}

      <div
        className="w-full h-full flex items-center justify-center"
        style={{ padding: '64px 56px 80px' }}
      >
        {isVideoUrl(photos[currentIdx]) ? (
          <video
            src={photos[currentIdx]}
            className="max-h-full max-w-full rounded-sm shadow-2xl"
            controls
            autoPlay
            onClick={(e) => e.stopPropagation()}
          />
        ) : (
          <img
            src={photos[currentIdx]}
            alt={`photo ${currentIdx + 1}`}
            className="max-h-full max-w-full object-contain rounded-sm shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        )}
      </div>

      {photos.length > 1 && (
        <button
          className="absolute right-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-black/40 flex items-center justify-center text-white/80 hover:text-white hover:bg-black/60 transition-colors"
          onClick={(e) => { e.stopPropagation(); onSetIdx((currentIdx + 1) % photos.length); }}
        >
          <ChevronRight size={22} />
        </button>
      )}

      {photos.length > 1 && (
        <div className="absolute bottom-6 flex gap-2 z-10 pointer-events-none">
          {photos.map((_, i) => (
            <div
              key={i}
              className={`rounded-full transition-all ${i === currentIdx ? 'w-4 h-1.5 bg-white' : 'w-1.5 h-1.5 bg-white/40'}`}
            />
          ))}
        </div>
      )}
    </div>,
    document.body
  );
};

export default PhotoLightbox;
